import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { File, FileText, Phone, RefreshCcw, Sparkles } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../../Landing/footer.js';

const LegalLayout = ({ children, title }) => {
  const location = useLocation();
  const path = location.pathname;

  const navLinks = [
    { path: '/legal', label: 'Legal Hub', icon: <FileText className="h-4 w-4 mr-2" /> },
    { path: '/legal/privacy-policy', label: 'Privacy Policy', icon: <File className="h-4 w-4 mr-2" /> },
    { path: '/legal/terms-conditions', label: 'Terms & Conditions', icon: <File className="h-4 w-4 mr-2" /> },
    { path: '/legal/cancellation-refund', label: 'Cancellation & Refund', icon: <RefreshCcw className="h-4 w-4 mr-2" /> },
    { path: '/legal/free-demo-policy', label: 'Free Demo Policy', icon: <Sparkles className="h-4 w-4 mr-2" /> },
    { path: '/legal/contact-us', label: 'Contact Us', icon: <Phone className="h-4 w-4 mr-2" /> },
  ];

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navigation />

      <div className="flex-1 container mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Sidebar */}
          <aside className="md:col-span-1">
            <div className="bg-white p-4 rounded-lg shadow-sm">
              <nav className="space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`flex items-center px-3 py-2 text-sm font-medium rounded-md ${path === link.path
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-700 hover:bg-gray-100'
                      }`}
                  >
                    {link.icon}
                    {link.label}
                  </Link>
                ))}
              </nav>
            </div>
          </aside>

          {/* Main Content */}
          <main className="md:col-span-3 bg-white rounded-lg shadow-sm p-6">
            {children}
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LegalLayout;
